import { Grid, Paper, Typography } from '@material-ui/core';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';
import type { IqeProject, TestRun } from '../../interfaces/ui';
import StatusBadge from '../../common/StatusBadge';
import EnvironmentBadge from '../../common/EnvironmentBadge';
import { useStyles } from '../../../../styles';

interface ProjectInfoSummaryProps {
  project: IqeProject;
  currentVersion: TestRun | null;
}

export default function ProjectInfoSummary({
  project,
  currentVersion,
}: ProjectInfoSummaryProps) {
  const classes = useStyles();
  return (
    <Paper className={classes.overwiewCards}>
      <Typography className={classes.heading}>{project.name}</Typography>
      <Grid
        container
        spacing={2}
        className={`${classes.toolGrid} ${classes.projectDetailsFields}`}
      >
        <Grid item md={4} sm={4} xs={6}>
          <Typography className={classes.apmLabel}>Application URL</Typography>
          <Typography variant="body2" className={classes.apmValue}>
            {project.appUrl}
          </Typography>
        </Grid>
        <Grid item md={4} sm={4} xs={6}>
          <Typography className={classes.apmLabel}>Test plan URL</Typography>
          <Typography variant="body2" className={classes.apmValue}>
            {project.testPlanName}
            <a
              href={project.testPlanUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                color: 'inherit',
                marginLeft: '10px',
              }}
            >
              <OpenInNewOutlinedIcon style={{ fontSize: 16 }} />
            </a>
          </Typography>
        </Grid>
        {currentVersion && (
          <Grid item md={4} sm={4} xs={6}>
            <Typography className={classes.apmLabel}>Last run</Typography>
            <Typography variant="body2" className={classes.apmValue}>
              {currentVersion.createdAt?.toLocaleDateString()}
            </Typography>
          </Grid>
        )}
        <Grid item md={4} sm={4} xs={6}>
          <Typography className={classes.apmLabel}>Environment</Typography>
          <EnvironmentBadge environment={project.environment} />
        </Grid>
        <Grid item md={4} sm={4} xs={6}>
          <Typography className={classes.apmLabel}>Project status</Typography>
          <StatusBadge status={project.status} />
        </Grid>
        {project.createdAt && (
          <Grid item md={4} sm={4} xs={6}>
            <Typography className={classes.apmLabel}>Created date</Typography>
            <Typography variant="body2" className={classes.apmValue}>
              {project.createdAt.toLocaleDateString()}
            </Typography>
          </Grid>
        )}
        {currentVersion && (
          <>
            <Grid item md={4} sm={4} xs={6}>
              <Typography className={classes.apmLabel}>
                Test plan version
              </Typography>
              <Typography variant="body2" className={classes.apmValue}>
                v{currentVersion.transactionId.slice(-6).toUpperCase()}
              </Typography>
            </Grid>
            <Grid item md={4} sm={4} xs={6}>
              <Typography className={classes.apmLabel}>
                Modified date
              </Typography>
              <Typography variant="body2" className={classes.apmValue}>
                {currentVersion.createdAt?.toLocaleDateString()}
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Paper>
  );
}
